(function installMyCrystalsReorder() {
  const TOKEN_PATTERN = /^[A-Za-z0-9_-]{32,4096}$/;
  const PRIVATE_PROPERTIES = new Set([
    '_reorder_source_job_id', '_reorder_source_signature', '_reorder_photo_changed',
  ]);

  function productForm() {
    return document.querySelector('product-form form[action*="/cart/add"]')
      || document.querySelector('form[action*="/cart/add"]');
  }

  function setFormValue(form, name, value, dispatch = true) {
    if (value === null || value === undefined) return;
    const formId = form.getAttribute('id') || '';
    let controls = Array.from(document.querySelectorAll(`[name="${CSS.escape(name)}"]`))
      .filter((control) => !control.getAttribute('form') || control.getAttribute('form') === formId || form.contains(control));
    if (!controls.length) {
      const input = document.createElement('input');
      input.type = 'hidden'; input.name = name; form.append(input); controls = [input];
    }
    controls.forEach((control) => {
      control.value = String(value);
      if (dispatch) {
        control.dispatchEvent(new Event('input', {bubbles:true}));
        control.dispatchEvent(new Event('change', {bubbles:true}));
      }
    });
  }

  function renderBanner(form, photoUrl, error = false) {
    document.querySelector('[data-my-crystals-reorder-banner]')?.remove();
    const banner = document.createElement('aside');
    banner.className = `my-crystals-reorder${error ? ' my-crystals-reorder--error' : ''}`;
    banner.dataset.myCrystalsReorderBanner = '';
    if (photoUrl && !error) {
      const image = document.createElement('img'); image.src = photoUrl;
      image.alt = 'Photo from your original crystal order'; banner.append(image);
    }
    const copy = document.createElement('div');
    copy.innerHTML = error
      ? '<strong>This reorder link is no longer available</strong><p>Go back to My crystals and select Customize & reorder again.</p>'
      : '<span class="my-crystals-reorder__eyebrow">PAST ORDER</span><strong>Your crystal is ready to customize</strong><p>We added the saved details from your original order. Review or change anything before adding it to your cart.</p>';
    banner.append(copy);
    (form.closest('product-info')?.querySelector('.product__info-container') || form.parentElement)?.prepend(banner);
  }

  async function hydrate(form, payload) {
    const properties = payload.properties && typeof payload.properties === 'object' ? payload.properties : {};
    Object.entries(properties).forEach(([key, value]) => {
      if (value !== '' || PRIVATE_PROPERTIES.has(key)) setFormValue(form, `properties[${key}]`, value);
    });
    setFormValue(form, 'quantity', Math.max(1, Number(payload.quantity) || 1), false);

    const text = document.querySelector('.engrave-text__input input');
    if (text) {
      text.value = String(payload.selection?.engraving_text || '');
      text.dispatchEvent(new Event('input', {bubbles:true}));
    }
    const font = String(payload.selection?.engraving_font || 'Georgia');
    Array.from(document.querySelectorAll('.engrave-text__styles input')).find((input) => input.value === font)?.click();

    let photoUrl = String(payload.source_photo_order_url || '');
    if (photoUrl && (window.NativePhotoCompat?.legacyUrl(photoUrl) || window.NativePhotoCompat?.ownedUrl(photoUrl))) {
      const original = photoUrl;
      const asset = await window.NativePhotoCompat.adopt(original);
      photoUrl = asset.url;
      setFormValue(form, 'properties[_media_asset_id]', asset.asset_id);
      setFormValue(form, 'properties[_media_legacy]', 'true');
      const coordinator = [...document.querySelectorAll('ccm-live-preview-v3')].find(item => item.productForm === form);
      await coordinator?.restoreHistoricalPhoto(original);
    }
    if (photoUrl) {
      setFormValue(form, 'properties[Photo]', photoUrl);
      const image = document.getElementById('uploaded-img'); if (image) image.src = photoUrl;
      document.getElementById('uploaded-image')?.classList.remove('hide');
      const picker = document.getElementById('product-file-picker'); if (picker) picker.textContent = 'Change photo';
      text?.dispatchEvent(new Event('input', {bubbles:true}));
      const sourceInput = document.getElementById('source-photo');
      if (sourceInput) {
        new MutationObserver(() => {
          setFormValue(form, 'properties[_reorder_photo_changed]', 'true', false);
        }).observe(sourceInput, {attributes:true, attributeFilter:['value']});
      }
    }
    renderBanner(form, photoUrl);
  }

  async function start() {
    const url = new URL(window.location.href);
    const token = url.searchParams.get('ccm_reorder') || '';
    if (!token) return;
    const form = productForm();
    if (!form) return;
    if (!TOKEN_PATTERN.test(token)) return renderBanner(form, '', true);
    try {
      const response = await fetch(`/apps/crystal-settings/api/customer-account/v1/reorder/resolve?token=${encodeURIComponent(token)}`, {
        credentials:'same-origin', cache:'no-store', headers:{Accept:'application/json'},
      });
      if (!response.ok) throw new Error('expired');
      await hydrate(form, await response.json());
      url.searchParams.delete('ccm_reorder');
      window.history.replaceState({}, '', url.pathname + url.search + url.hash);
    } catch (_error) { renderBanner(form, '', true); }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();
